import { Skeleton } from '@cannect/new-components/atoms'

export const SubscriptionDetailSkeleton = () => (
  <div className="flex w-full flex-col gap-4" aria-busy="true" aria-label="Carregando assinatura">
    <Skeleton className="h-6 w-40" />
    <Skeleton className="h-40 w-full rounded-xl" />
    {[0, 1, 2].map((key) => (
      <Skeleton key={key} className="h-32 w-full rounded-xl" />
    ))}
  </div>
)
